function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M6 10L1 5.5 6 1",
  stroke: "#FFF",
  strokeWidth: 1.5,
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var SvgDateChevronLeft = function SvgDateChevronLeft(props) {
  return React.createElement("svg", _extends({
    width: 7,
    height: 11,
    viewBox: "0 0 7 11"
  }, props), _ref);
};

export default SvgDateChevronLeft;